import src from "IMAGE";
export default { src, width: 512, height: 512, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAM0lEQVR42l2NiQkAMAgDM6m9/adoseKHCCaeRjoi+pdsyGfUaL5oRhCFs0/yB4NySWZxAUXqF8yI20qZAAAAAElFTkSuQmCC"};
